import {openPtx, openWithParams, getUrl} from "./main_ptx";


/**
 * bulk resolve all resolvable items on page
 * @alias Ptx.resolver.bulkResolve
 * @param type - incident, trackPoint etc.
 * @param ctx - jQ context where to search
 */
export function bulkResolve(type, ctx) {
    var urlPath = getUrl('/user/resolver/resolve.json');
    
    $('.resolve[data-type="'+type+'"]', ctx).each(function() {
        var output = $(this);
        var requestData = {
        	type:type,
        	lat:output.data('lat'),
			lon: output.data('lon'),
        	entityId:output.data('entity-id'),
        	unitId:output.data('unit-id'),
        	clientId:output.data('client-id')
        };

        openWithParams(urlPath, 'GET', requestData, function (data, svr) {
        	if (data.state != null) {
              output.html(data.state.detail);
          } else {
              output.html(data.address);
          }
        }, {showLoader: false});
    });
}

/**
 * message resolve all resolvable items on page
 * @alias Ptx.resolver.msgResolve
 * @param ctx - jQ context where to search
 */
export function msgResolve(ctx) {
	var urlPath = getUrl('/user/resolver/i18n.json');
	var locations = [];
	var keysForResolve = {};
    $('.resolve[data-key]', ctx).each(function() {
    	locations.push($(this));
    	var key = $(this).data('key');
    	keysForResolve[key] = '1';
    });

    // create array of resolved keys
  	var p = {};
  	p.k = [];
  	for (var key in keysForResolve) {
  		if (key === Ptx.getMsg(key)) {
  			p.k.push(key);
  		} 
  	}
  	
   	if (p.k.length > 0) {
   		var opts = {
            showLoader: false,
            callbackSecondParam: p
        };
      	openWithParams(urlPath, 'GET', p, function(data, rqData) {
    		for (var i = 0; i < data.length; i++) {
    			var tuple = data[i];
				Ptx.setMsg(tuple.k, tuple.m);
    		}
    		replaceMsg(locations);
    	}, opts);
    } else {
    	replaceMsg(locations);
    }
}

/**
 * @alias Ptx.resolver.replaceMsg
 * @param arr
 */
export function replaceMsg(arr){
	for (var i = 0; i<arr.length; i++) {
		var l = arr[i];
		var k = l.data('key');
		var toTitle = l.data('put-to-title');
		if (toTitle == true) {
			var title = l.attr('title');
			l.attr('title', title + ' '+ Ptx.getMsg(k));
		} else {
			l.html(Ptx.getMsg(k));
		}
	}
}

/**
 * Resolve unit address from parameters and unit position in time
 * @alias Ptx.resolver.getUnitAddress
 * @param unitId
 * @param date - locale dependent date format
 * @param time - locale dependent time format
 * @param callback(data,srv) - function that can use data.address from given response, see Ptx.fn.openPtx for details 
 */
export function getUnitAddress(unitId, date, time, callback) {
	var p = {unitId : unitId , date : date, time : time}
	openPtx('/service/fuelling/address.json', "GET", p, callback, {showLoader: false});
}
